import React, {Ref, useCallback, useEffect, useRef, useState} from 'react'
import {Select, Spin, message, InputNumber, FormInstance, DatePicker} from 'antd'
// import moment from 'moment'
import dayjs from 'dayjs'
import {SDrawerOrModal, SGeneralForms, STriggerModal} from 'shj-components'
import {achievementChannelTypeUpdateById, addAchievementChannelType} from "@/services/customerServices.ts";

const {Option} = Select

interface IAddOrEditProps {
  id?: number
  setVisible: (value: boolean) => void
  armed: React.MutableRefObject<any>
  category: React.MutableRefObject<any>
  visible: boolean
  listRef: any
  editData: object & { performanceCycleMonthId: string | number }
}

export default function AddOrEdit(props: IAddOrEditProps) {
  const {
    editData,
    id,
    visible,
    setVisible,
    listRef,
    armed,
  } = props;
  const [loading, setLoading] = useState<boolean>(false)
  const formRef: Ref<any> = useRef()

  const onFinish = async (value: any) => {
    const _value = {...value}
    _value.id = id
    _value.year = dayjs(_value.yearMonth).format('YYYY')
    _value.month = dayjs(_value.yearMonth).format('M')
    delete _value.yearMonth
    const apiFn = id ? achievementChannelTypeUpdateById : addAchievementChannelType
    setLoading(true)
    apiFn(_value).then(res => {
      message.success(res.message || '操作成功')
      setVisible(false)
      listRef.current.reload()
      const form: FormInstance = formRef.current?.onFormRef()
      form.resetFields()
    }).finally(() => {
      setLoading(false)
    })
  }

  const onOk = () => {
    const form = formRef.current?.onFormRef()
    form.validateFields().then((value: any) => {
      onFinish(value)
    })
  }

  const onCancel = useCallback(() => {
    const form: FormInstance = formRef.current?.onFormRef()
    form.resetFields()
    setVisible(false)
  }, [])

  useEffect(() => {
    const form = formRef.current?.onFormRef()
    if (editData?.id) {
      form.setFieldsValue({...editData, yearMonth: dayjs(editData.year + '-' + editData.month)})
    } else {
      form.setFieldsValue({})
    }
  }, [editData])

  return (
      <SDrawerOrModal
          title={id ? '编辑' : '新增'}
          // destroyOnClose={true}
          // forceRender
          // maskClosable
          // confirmLoading={loading}
          onCancel={onCancel}
          onOk={onOk}
          // cancelText="取消"
          open={visible}
          // width={500}
      >
        <SGeneralForms
            layout="vertical"
            onFinish={onFinish}
            ref={formRef}
            configs={[
              {
                formItem: [
                  {
                    label: '军种',
                    name: 'channelTypeId',
                    required: true,
                    spanCol: 24,
                    labelCol: {
                      span: 24,
                    },
                    children: (
                        <Select disabled={!!id} placeholder="请选择" showSearch allowClear optionFilterProp={'children'}>
                          {armed.current &&
                              armed.current?.map((item: any) => (
                                  <Option key={item.id} value={item.id}>
                                    {item.typeName}
                                  </Option>
                              ))}
                        </Select>
                    ),
                  },
                  {
                    label: '年月',
                    name: 'yearMonth',
                    spanCol: 24,
                    required: true,
                    children: <DatePicker picker="month"/>,
                  },
                  {
                    label: '战略目标（万）',
                    spanCol: 24,
                    required: true,
                    name: 'performanceObjectivesAmount',
                    children: <InputNumber precision={3} min={0.001} max={999999999999} placeholder="请输入"
                                           style={{width: '100%'}}/>,
                  },
                  {
                    label: '理想目标（万）',
                    spanCol: 24,
                    required: true,
                    name: 'pkTargetAmount',
                    children: <InputNumber precision={3} min={0.001} max={999999999999} placeholder="请输入"
                                           style={{width: '100%'}}/>,
                  },
                ],
              },
            ]}
        />
    </SDrawerOrModal>
  )
}